import { Box, Typography } from "@mui/material";
import React from "react";
import { NotificationFullData } from "../../layout/UserNotification";
import useThemeStore from "../../services/store/useThemeStore";
import { titleStyles, wrapperStyles } from "./BookingStarted";
import { contentStyles } from "./BookingStarted";
import { DateNTime } from "../../utils/dateTime";
import { useTranslation } from "react-i18next";

const BookingStart = ({
  notification,
}: {
  notification: NotificationFullData;
}) => {
  const { darkMode } = useThemeStore();
  const { t } = useTranslation();
  return (
    <Box sx={wrapperStyles(darkMode)}>
      {/* <Box sx={iconBoxStyles(darkMode)}>
        <PlayCircle sx={{ color: "#16a34a", fontSize: 24 }} />
      </Box> */}
      <Box sx={contentStyles}>
        <Typography sx={titleStyles(darkMode)}>
          {t("booking_starting_soon", { ns: "notification" })}
        </Typography>
        <Typography
          sx={{ color: "#64748b", font: "var(--body-xs)", fontWeight: 400 }}
        >
          {notification.message}
        </Typography>
        {notification?.created_at && (
          <Typography
            sx={{
              font: "var(--semibold-xxs)",
              color: darkMode ? "#9ca3af" : "#64748b",
              fontWeight: 500,
            }}
          >
            {DateNTime.formatRelative(notification.created_at)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default BookingStart;
